import { Box } from "@mui/material";
import type { AnalysisCardId } from "src-next/modules/clinical-insights/types/analysisTypes";
import { AnalysisSelectCard } from "./AnalysisSelectCard";
import type { AnalysisCardConfig } from "./analysisCardTypes";

interface AnalysisCardRowsProps {
  treatmentCards: AnalysisCardConfig[];
  diagnosticsCards: AnalysisCardConfig[];
  selectedAnalysisId: AnalysisCardId;
  isBusy: boolean;
  onSelect: (id: AnalysisCardId) => void;
}

function renderCardRow(
  cards: AnalysisCardConfig[],
  selectedAnalysisId: AnalysisCardId,
  isBusy: boolean,
  onSelect: (id: AnalysisCardId) => void
) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: `repeat(${cards.length}, minmax(148px, 1fr))`,
          md: `repeat(${cards.length}, minmax(0, 1fr))`,
        },
        gap: 1.25,
        minWidth: 0,
        width: "100%",
        overflowX: { xs: "auto", md: "visible" },
        scrollbarWidth: "thin",
        pb: { xs: 0.25, md: 0 },
      }}
    >
      {cards.map((card) => (
        <AnalysisSelectCard
          key={card.id}
          card={card}
          isSelected={selectedAnalysisId === card.id}
          showBusySpinner={isBusy && selectedAnalysisId === card.id}
          onSelect={onSelect}
        />
      ))}
    </Box>
  );
}

export function AnalysisCardRows({
  treatmentCards,
  diagnosticsCards,
  selectedAnalysisId,
  isBusy,
  onSelect,
}: AnalysisCardRowsProps) {
  return (
    <>
      {renderCardRow(treatmentCards, selectedAnalysisId, isBusy, onSelect)}
      {renderCardRow(diagnosticsCards, selectedAnalysisId, isBusy, onSelect)}
    </>
  );
}
